import { render, staticRenderFns } from "./EventPopupPanel.vue?vue&type=template&id=bd5e95a0&scoped=true&"
import script from "./EventPopupPanel.vue?vue&type=script&lang=ts&"
export * from "./EventPopupPanel.vue?vue&type=script&lang=ts&"
import style0 from "./EventPopupPanel.vue?vue&type=style&index=0&id=bd5e95a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5e95a0",
  null
  
)

export default component.exports